import React from 'react'
import { Link } from 'gatsby'
import { OutboundLink } from "gatsby-plugin-google-analytics" 

import wyeast from '../img/wyeast-logo.jpeg'
import daybreak from '../img/daybreak-logo.jpg'
import trailbutter from '../img/trailbutter-logo.png'
import territory from '../img/territory-logo.png'
// import facebook from '../img/social/facebook.svg'
// import instagram from '../img/social/instagram.svg'
// import twitter from '../img/social/twitter.svg'
// import vimeo from '../img/social/vimeo.svg'

const Footer = class extends React.Component {
  render() {
    return (
      <div>
        <div className="content">
          <div className="content has-text-centered">
            <OutboundLink href="https://www.daybreakracing.com" target="_blank">
              <img
                src={daybreak}
                alt="Daybreak Racing"
                style={{ width: '224px', height: '224px', verticalAlign: 'middle', margin: '10px' }}
              />
            </OutboundLink>
            <OutboundLink href="https://www.trailbutter.com" target="_blank">
              <img
                src={trailbutter}
                alt="Trail Butter"
                style={{ width: '225px', height: '153px', verticalAlign: 'middle', margin: '10px' }}
              />
            </OutboundLink>
            <OutboundLink href="https://territoryrun.co" target="_blank">
              <img
                src={territory}
                alt="Territory Run Co."
                style={{ width: '225px', height: '68px', verticalAlign: 'middle', margin: '10px' }}
              />
            </OutboundLink>
            <OutboundLink href="https://www.wyeastwolfpack.com" target="_blank">
              <img
                src={wyeast}
                alt="Trail Butter"
                style={{ width: '225px', height: '225px', verticalAlign: 'middle', margin: '10px' }}
              />
            </OutboundLink>
          </div>
        </div>
        <footer className="footer has-background-black has-text-white-ter">
          <div className="content has-text-centered has-background-black has-text-white-ter">
            <div className="container has-background-black has-text-white-ter">
              <div className="columns">
                <div className="column is-8">
                  <section className="menu">
                    <ul className="menu-list">
                      <li>
                        <Link to="/" className="navbar-item">
                          Home
                        </Link>
                      </li>
                      <li>
                        <Link className="navbar-item" to="/about">
                          About
                        </Link>
                      </li>
                      <li>
                        <Link className="navbar-item" to="/challenge">
                          Challenges
                        </Link>
                      </li>
                      <li>
                        <a
                          className="navbar-item"
                          href="/admin/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Admin
                        </a>
                      </li>
                    </ul>
                  </section>
                </div>
                <div className="column is-4 social">
                  {/* <a title="facebook" href="https://facebook.com">
                    <img
                      src={facebook}
                      alt="Facebook"
                      style={{ width: '1em', height: '1em' }}
                    />
                  </a>
                  <a title="twitter" href="https://twitter.com">
                    <img
                      className="fas fa-lg"
                      src={twitter}
                      alt="Twitter"
                      style={{ width: '1em', height: '1em' }}
                    />
                  </a>
                  <a title="instagram" href="https://instagram.com">
                    <img
                      src={instagram}
                      alt="Instagram"
                      style={{ width: '1em', height: '1em' }}
                    />
                  </a>
                  <a title="vimeo" href="https://vimeo.com">
                    <img
                      src={vimeo}
                      alt="Vimeo"
                      style={{ width: '1em', height: '1em' }}
                    />
                  </a> */}
                </div>
              </div>
            </div>
          </div>
        </footer>

      </div>
    )
  }
}

export default Footer
